import React from "react";
import {labelizeUnderScoreText} from "crqlar-react-common/dist/utils/text.util";
import {ElementChip} from "./base/ElementChip";
import {ElementChipList} from "./base/ElementChipList";

export function SimpleChipElement({
    values,
    asPrint = false,
}: {
    values?: string[];
    asPrint?: boolean;
}) {
    const labels = Array.from(new Set((values ?? []).filter(Boolean).map(labelizeUnderScoreText)));

    if (!labels.length) return null;

    if (asPrint) return <>{labels.join(", ")}</>;

    return (
        <ElementChipList>
            {labels.map(label => (
                <ElementChip key={label} text={label}/>
            ))}
        </ElementChipList>
    );
}
